export const getAssetLookupTable = (assets: any, lookupTable: any): void => {
  const assetValues: any[] = Object.values(assets);
  if(assetValues.length > 0) {
      assetValues.forEach((asset: any) => {
        if (asset) {
          if (asset.assetId && asset.json) {
              if(asset.json.fields && asset.json.fields.length > 0) {
                  getAssetLookupTable(asset.json.fields, lookupTable);
              }
              lookupTable[asset.json.elementId] = asset;
          } else {
              if(asset.fields && asset.fields.length > 0) {
                  getAssetLookupTable(asset.fields, lookupTable);
              }
              lookupTable[asset.elementId] = asset;
          }
        }
      })
  }
}